import React from 'react';
import { EditDateInline } from './shared/EditDateInline';
import { TransactionValidationSchemaGenerator } from '../../EditTransactionPrice/TransactionValidationSchema';
import { SmallBodyText } from '../../../../../ui-toolkit';
import { SummaryItemWithTooltip } from '../../../../shared/Summary/SummaryItem/SummaryItemWithTooltip';
import { useUpdateOrderFromSummaryItem } from '../hooks/useUpdateOrderFromSummaryItem';
import { getDateString } from '../../../../../ui-toolkit/utilities/getDateString';

export const RateLockExpiration: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();
  return (
    <SummaryItemWithTooltip
      label={`Rate Lock Expiration`}
      tab={`summary`}
      tooltip={EditDateInline}
      tooltipProps={{
        validationSchema: TransactionValidationSchemaGenerator(
          order.transaction.transaction_category,
          'rate_lock_expiration'
        ),
        value: order.transaction.rate_lock_expiration,
        onUpdateOrder: async (value: string | null) =>
          await onPatchOrderInformation({ rateLockExpiration: value ?? null }),
        highlightDate: 'today',
      }}
    >
      {getDateString('LLLL d, yyyy', order.transaction.rate_lock_expiration) || (
        <SmallBodyText intent={'faded'}>Not Scheduled</SmallBodyText>
      )}
    </SummaryItemWithTooltip>
  );
};
